<template>
  <section>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="content">
            <h3 class="has-text-info">直接拖曳即可對區塊排序</h3>
          </div>
        </div>
      </div>
      <div class="level-right">
        <p class="level-item">
          <a class="button is-primary" @click="onUpdate">
            <span>{{ $t('attributes.update') }}</span>
          </a>
        </p>
      </div>
    </nav>

    <b-table
      :data="sections"
      :loading="loading"
      :mobile-cards="false"
      narrowed
      bordered
      draggable
      @dragstart="dragstart"
      @drop="drop"
      @dragover="dragover"
      @dragleave="dragleave"
    >
      <b-table-column
        field="sort"
        :label="$t('attributes.sort')"
        centered
        v-slot="props"
      >
        {{ props.row.sort }}
      </b-table-column>

      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        v-slot="props"
      >
        <b-input v-model="props.row.name"></b-input>
      </b-table-column>

      <b-table-column :label="$t('attributes.status')" centered v-slot="props">
        <b-switch v-model="props.row.status"></b-switch>
      </b-table-column>

      <template #empty>
        <section class="section">
          <div v-if="!loading" class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
            </p>
            <p>Nothing here.</p>
          </div>
        </section>
      </template>
    </b-table>
  </section>
</template>

<script>
import { CATALOG_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'SectionList',

  props: {
    catalog: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      catalog_no: this.catalog.catalog_no,
      sections: [],

      draggingRow: null,
      draggingRowIndex: null
    }
  },
  watch: {
    catalog(newCatalog) {
      this.catalog_no = newCatalog.catalog_no
      this.loadSectionsAsync(newCatalog.catalog_no)
    }
  },
  mounted() {
    this.loadSectionsAsync(this.catalog.catalog_no)
  },
  methods: {
    async loadSectionsAsync(catalog_no) {
      try {
        this.loading = true
        const api = `${CATALOG_API}/${catalog_no}/sections`
        const res = await this.axios.get(api)
        const sections = res.data.data

        this.sections = sections.sort((t1, t2) => t1.sort - t2.sort)
      } catch (e) {
        this.sections = []

        notifyService.fetch_error('catalog_section', e)
      } finally {
        this.loading = false
      }
    },
    async onUpdate() {
      try {
        this.loading = true
        const api = `${CATALOG_API}/${this.catalog_no}/sections`
        const res = await this.axios.put(api, this.sections)
        const sections = res.data.data

        this.sections = sections.sort((t1, t2) => t1.sort - t2.sort)

        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        this.sections = []

        notifyService.update_error(e)
      } finally {
        this.loading = false
      }
    },
    dragstart(payload) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      const droppedOnRowIndex = payload.index

      let sections = [...this.sections]

      sections.splice(this.draggingRowIndex, 1)

      sections.splice(droppedOnRowIndex, 0, this.draggingRow)

      this.sections = sections.map((b, idx) => {
        return { ...b, sort: idx + 1 }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  td {
    vertical-align: middle !important;
  }
}
</style>
